// CSS
import 'font-awesome/css/font-awesome.min.css';
import 'ionicons/dist/css/ionicons.min.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'admin-lte/dist/css/AdminLTE.css';
import 'admin-lte/dist/css/skins/skin-blue.min.css';
import './app.css';
// JS
import 'jquery/src/jquery';
import 'jquery-slimscroll/jquery.slimscroll';
import 'fastclick/lib/fastclick';
import 'bootstrap/dist/js/bootstrap';
import 'admin-lte/dist/js/app';
import './app'; // Arquivo de configuracao dos plugins
// ReactJS
import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, hashHistory, IndexRoute } from 'react-router';
// Componentes
import App from './modulos/App';
import Home from './modulos/layout/Home';
// Componentes - Protocolo
import IndiceProtocolo from './modulos/protocolo/IndiceProtocolo';
import ConsultarProtocolo from './modulos/protocolo/consultar/ConsultarProtocolo';
// Componentes - Manuais
import Manuais from './modulos/manuais/Manuais';

ReactDOM.render(
  <Router history={hashHistory}>
    <Route name="Início" path="/" component={App}>
      <IndexRoute component={Home} />
      <Route name="Protocolo" path="protocolo" component={IndiceProtocolo}>
        <Route name="Consultar Protocolo" path="consultar" component={ConsultarProtocolo} />
      </Route>
      <Route name="Manuais" path="manuais" component={Manuais} />
    </Route>
  </Router>
  , document.getElementById('root')
);


// WEBPACK FOOTER //
// ./src/index.js